<template>
  <div class="gananWebForensicsUp">
    <div class="topNav">
      <img class="img" src="../../assets/index.png" alt="">
      <div class="r">></div>
      <div class="text" @click="onUrl('/gananWebForensics')">版权服务</div>
      <div class="r">></div>
      <div class="text active">网页取证</div>
    </div>
    <div class="topTitle">
      <div class="title">网页取证</div>
      <div class="msg">截取网页后，及时上传至区块链，即可永久固定证据</div>
    </div>
    <div class="contentBox">
      <div class="content">
        <div class="title">网页取证</div>
        <div class="formBox">
          <div class="left">
            <div class="search-group">
                <input v-model="url" :disabled="urlDisabled"  @keyup.enter="urlEnter" type="text" placeholder="请输入您需要取证的网址"/>
            </div>
            <ul v-if="obtainEvidenceData && obtainEvidenceData.length>0" class="obtain_evidence_group">
                <li class="obtain_evidence_item" v-for="(item,index) in obtainEvidenceData" :key="index">
                    <Tooltip max-width="440" :content="item">
                        <span class="obtain_evidence_item_content">{{item}}</span>
                    </Tooltip>
                    <img @click="removeUrl(index)" class="obtain_evidence_item_close" src="@/views/vipClip/vip/lawcomponent/images/ty_close.png" alt='版权登记'>
                </li>
            </ul>
            <ul v-else class="obtain_evidence_groupNodata">
                批量取证可按回车分隔，例：<br>
                https://www.yeahip.com<br>
                https://www.baidu.com<br>
                http://www.tmall.com<br>
                <br>
                批量取证最多支持10条
            </ul>
          </div>
          <div class="right">
            <div class="name">温馨提示：</div>
            <div class="text">
              1.支持对公开访问的网页进行证据保全，不适用需要登录才可访问的网页；<br>
              2.如需批量网页取证功能，可直接通过回车分隔输入，最多支持10条；<br>
              3.网页取证完毕后，建议及时前往个人中心对抓取内容进行检查； <br>
              4.网页取证次数按所添加的目标网址数量进行计算；<br>
            </div>
          </div>
        </div>
        <div class="payMoney">服务费用： <span>{{(payMoney.bizPrice / 100).toFixed(2)}}</span>元/次</div>
        <el-button class="btn" @click="showPayWay()" id="addButton">确认提交</el-button>
      </div>
    </div>
    <!-- 前海版权公共服务平台支付 -->
    <payDalog ref="payDalog" :payOrder="payOrder" @confirm="confirm"></payDalog>
    <successfulDalog ref="successfulDalog" :payOrder="payOrder"></successfulDalog>
  </div>
</template>

<script>
    import {_saveWebpage, _getresave} from "@/api/evidence.js";
    import Cookies from "js-cookie";
    import $ from 'jquery';
    import myczPay from '@/views/vipClip/vip/lawcomponent/myczpay';
    import monitorBag from '@/views/vipClip/monitor/components/monitorBag';
    import generalframe from '@/views/vipClip/vip/lawcomponent/generalframe.vue'
    import payWay from '@/views/main-components/pay-way';
    import payDalog from '@/viewsGangAn/components/payDalog';
    import successfulDalog from '@/viewsGangAn/components/successfulDalog';
    import {configGetBzPrice} from "@/api/index.js";
    export default {
        metaInfo: {
            title: '网页取证|前海版权综合服务平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,前海版权综合服务平台,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '网页取证,前海版权综合服务平台,人人都是创作者，人人都是版权人。前海版权综合服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: "evidenceWeb",
        components: {
            monitorBag,
            myczPay,
            generalframe,
            payWay,
            payDalog,
            successfulDalog
        },
        data() {
            return {
                payOrder: '',
                url: "",
                showTip: false,
                orderSeqNo: "",
                myczPayState: false, //会员续费
                monitorBagState: false, //加油包
                showDialog: false,
                payWay: null,
                disabled: false,
                PayWayCom: '',
                obtainEvidenceData:[],
                urlDisabled:false,
                // 前海版权公共服务平台
                payMoney: {
                    bizPrice: 0
                },
            }
        },
        methods: {
            onUrl(url) {
                this.$router.push(url)
            },
            // 获取金额
            async configGetBzPrice() {
                let data = {
                    bizType: '03',
                    subBizType: '0301'
                }
                let res = await configGetBzPrice(data)
                this.payMoney = res.result
            },
            saveWebpage() {
                let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                console.log(userInfo)
                if (this.url && this.url.indexOf("http") == 0) {
                    this.showTip = false;
                    $("#addButton").attr("disabled", "disabled");

                    if (this.$route.query.id) {
                        _getresave({orderSeqNo: this.orderSeqNo}).then(res => {
                            if (res.code == 200) {
                                this.$router.push('/evidence-list')
                            } else {
                                toast(res.message)
                                $("#addButton").removeAttr("disabled");
                            }
                        });
                    } else {
                        const data = {
                            url: this.url,
														applyType: 'common',
                            registerId: userInfo && userInfo.id ? userInfo.id : '',
                        }
                        _saveWebpage(data).then(res => {
                            if (res.code == 200) {
                                this.$router.push('/evidence-list')
                            } else if (res.code == 214) {
                                toast("请购买会员后使用功能")
                                this.$router.push({path: '/huiyuan.html'})
                            } else if (res.code == 215) {
                                toast("VIP已到期，请续费")
                                this.myczPayState = true;
                                $("#addButton").removeAttr("disabled");
                            } else if (res.code == 216) {
                                //toast("剩余次数不足，请购买加油包")
                                this.monitorBagState = true;
                                $("#addButton").removeAttr("disabled");
                            } else if (res.code == 213) {
                                toast("请实名认证后使用功能")
                                if (userInfo.accountType == "person") {
                                    this.$router.push('/authentication')
                                } else {
                                    this.$router.push('/authentication')
                                }
                            } else {
                                toast(res.message)
                                $("#addButton").removeAttr("disabled");
                            }
                        });
                    }

                } else {
                    this.showTip = true;
                    $("#addButton").removeAttr("disabled");
                }

            },
            //会员续费
            myczPayFuc() {
                this.myczPayState = false;
            },
            //加油包
            monitorBagFuc() {
                this.monitorBagState = false;
            },
            showPayWay() {
                let _this = this
				let nowUrl = _this.url;
				let obtainEvidenceData = _this.obtainEvidenceData;
                let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                if (userInfo == '') {
                    _this.$store.state.app.showLoginOrRegistter = true;
                    return false
                }
				if(nowUrl && nowUrl.indexOf("http") == 0){
				    if(obtainEvidenceData.indexOf(nowUrl) == -1){
				        obtainEvidenceData.push(nowUrl)
						_this.url = '';
				    }
				    else{
				        toast('该目标网址已添加，请核对提交')
						return false
				    }
				    _this.obtainEvidenceData = obtainEvidenceData;
				}
				console.log(this.obtainEvidenceData);
				console.log(this.url);
                if (this.obtainEvidenceData && this.obtainEvidenceData.length>0) {

                    if (!userInfo || userInfo == '') {
                        _this.$store.state.app.showLoginOrRegistter = true;
                        return false;
                    }
                    _this.showTip = false;
                    _this.submitEvidence()

                }  else {
                    toast('请添加目标网址后，再提交')
                    _this.showTip = true;
                    //  $("#addButton").removeAttr("disabled");
                }
            },
            confirm(e,orderType) {
              if (e) {
                this.$refs.successfulDalog.closeDialog(orderType)
            	}
            },
            submitEvidence() {

                this.disabled = true
                if (this.$route.query.id) {
                    _getresave({orderSeqNo: this.orderSeqNo}).then(res => {
                        if (res.code == 200) {
                            this.$router.push('/evidence-list')
                        } else {
                            toast(res.message)
                            this.disabled = false;
                        }
                    });
                } else {
                    let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                    console.log(userInfo)
                    const data = {
                        urls: JSON.stringify(this.obtainEvidenceData) ,
												applyType: 'common',
                        registerId: userInfo && userInfo.id ? userInfo.id : '',
                    }
                    _saveWebpage(data).then(res => {
                        if (res.code == 200) {
                            this.payOrder = Array.isArray(res.result)?res.result[0].orderSeqNo:res.result.orderSeqNo
                            let cpayMoney = (this.payMoney.bizPrice / 100).toFixed(2) * this.obtainEvidenceData.length
                            this.$refs.payDalog.getPayInfoByOrderSeqNo(res.result,cpayMoney,'evidenceAndTort')

                        } else if (res.code == 214) {
                            toast("请购买会员后使用功能")
                            this.$router.push({path: '/huiyuan.html'})
                        } else if (res.code == 215) {
                            toast("VIP已到期，请续费")
                            this.myczPayState = true;
                            this.disabled = false;
                        } else if (res.code == 216) {
                            //toast("剩余次数不足，请购买加油包")
                            this.monitorBagState = true;
                            this.disabled = false;
                        } else if (res.code == 213) {
                            toast("请实名认证后使用功能")
                            if (userInfo.accountType == "person") {
                                this.$router.push('/authentication')
                            } else {
                                this.$router.push('/authentication')
                            }
                        } else {
                            toast(res.message)
                            this.disabled = false;
                        }
                    });
                }
            },

            //输入框回车事件
            urlEnter(e) {
                this.checkObtainEvidence();
            },
            //检查url事件
            checkObtainEvidence(){
                // let urlRule = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/;
                let nowUrl = this.url;
                let obtainEvidenceData = this.obtainEvidenceData;
                if(obtainEvidenceData.length>=10){
                    toast('批量取证，一次最多可选择十个');
                    return
                }

                if(nowUrl && nowUrl.indexOf("http") == 0){
                    if(obtainEvidenceData.indexOf(nowUrl) == -1){
                        obtainEvidenceData.push(nowUrl)
                        this.url = '';
                    }
                    else{
                        toast('该目标网址已添加，请核对提交')
                    }

                    this.obtainEvidenceData = obtainEvidenceData;
                }
                else{
                    toast('请输入正确的目标网址')
                }
            },

            //删除url事件
            removeUrl(index){
                console.log(index)
                let obtainEvidenceData = this.obtainEvidenceData;
                obtainEvidenceData.splice(index, 1);
                this.obtainEvidenceData = obtainEvidenceData;
            },




            queryChange(e) {
                if (this.url.length >= 10) {
                    this.showTip = true;
                    return
                }
                if (e && e.indexOf("http") == 0) {
                    this.showTip = false
                } else {
                    this.showTip = true
                }

            },

        },
        created() {
            this.configGetBzPrice()
            this.$store.commit("setFooterColor", '#fff');
            //  this.url = localStorage.getItem("evidence_web")? JSON.parse(localStorage.getItem("evidence_web")).url : ''
            //  console.log(JSON.parse(localStorage.getItem("evidence_web")).url)
            if (this.$route.query.id) {
                this.getRequest('/evidenceWebpage/get/' + this.$route.query.id).then(res => {
                    if (res.code == 200) {
                        this.url = res.result.url;
                        this.orderSeqNo = res.result.orderSeqNo;
                    }
                })
            } else if (this.$route.query.url) {
                // this.url = this.$route.query.url
                let obtainEvidenceData = this.obtainEvidenceData;

                obtainEvidenceData.push(this.$route.query.url);
                this.obtainEvidenceData = obtainEvidenceData;
            }
        },
        watch: {
            'url': {
                handler: function () {
                    // let urlRule = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/;

                    if (this.url && this.url.indexOf("http") == 0) {
                        this.showTip = false
                    } else {
                        this.showTip = true
                    }
                }
            },
        },

    };
</script>

<style lang="less" scoped>
.gananWebForensicsUp{
  background: #F4F8FC;
  color: #333;
}
.topNav{
  display: flex;
  align-items: center;
  width: 1200px;
  margin: auto;
  padding: 18px 0;
  font-size: 14px;
  color:#999999;
  .img{
    width: 16px;
    height: 16px;
  }
  .r{
    margin: 0 10px;
  }
  .active{
    color: #2196F3;
  }
  .text{
      cursor: pointer;
  }
}
.topTitle{
  width: 1200px;
  background: #fff;
  margin: auto;
  text-align: center;
  padding: 33px;
  border-radius: 8px;
  .title{
    text-align: center;
    font-size: 22px;
    font-weight: 700;
    font-family: 'AlibabaPuHuiTi';
  }
  .msg{
    font-size: 14px;
    margin-top: 6px;
    color:#666666;
  }
}
.contentBox{
  padding: 20px 0;
  .content{
    width: 1200px;
    background: #fff;
    border-radius: 8px;
    padding: 36px 48px;
    margin: auto;
    .title{
      font-size: 20px;
      font-weight: 700;
      position: relative;
      font-family: 'AlibabaPuHuiTi';
      z-index: 2;
      &::before{
        content: '';
        position: absolute;
        width: 36px;
        background: #2196F3;
        height: 6px;
        border-radius: 3px;
        left: 0;
        bottom: 3px;
        z-index: -1;
      }
    }
    .formBox{
      padding: 52px 0 0 0;
      display: flex;
      .left{
        flex: 0 0 712px;
        border: 1px solid rgba(207, 207, 207, 1);
        border-radius: 4px;
        /deep/ .el-textarea__inner{
          min-height: 218px !important;
          padding: 20px;
        }
      }
      .right{
        font-size: 14px;
        color: #BDBDBD;
        flex: 1;
        margin-left: 47px;
        .text{
          line-height: 24px;
          margin-top: 12px;
        }
      }
    }
    .payMoney{
      font-size: 14px;
      margin-top: 30px;
      span{
        color: #FF2121;
        font-size: 26px;
        font-weight: 700;
        margin: 0 4px 0 10px;
      }
    }
    .btn{
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      width: 170px;
      height: 40px;
      background: #2196F3;
      border-radius: 4px 4px 4px 4px;
      display: block;
      margin: 56px auto;
      cursor: pointer;
    }
  }

}
.search-group {
  height: 50px;
  background: rgba(255, 255, 255, 1);


  display: flex;
  justify-content: center;
  position: relative;
  z-index: 200;

  input {
      border: none;
      outline: none;
      width: 100%;
      padding: 0 15px;
  }

  input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
      color: rgba(153, 153, 153, 1);
      font-size: 14px;
  }

  input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
      color: rgba(153, 153, 153, 1);
      font-size: 14px;
  }

  input::-moz-placeholder { /* Mozilla Firefox 19+ */
      color: rgba(153, 153, 153, 1);
      font-size: 14px;
  }

  input:-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: rgba(153, 153, 153, 1);
      font-size: 14px;
  }
}
.obtain_evidence_groupNodata{
    color: #BDBDBD;
    font-size: 14px;
    padding: 0 10px;
}
.obtain_evidence_group{
  background: #fff;
  padding: 20px;
  list-style: none;
  margin-bottom: 20px;

  .obtain_evidence_item{
      display: flex;
      justify-content: space-between;
      padding-bottom: 10px;

      &:last-child{
          padding-bottom: 0;
      }

      .obtain_evidence_item_content{
          max-width: 440px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: inline-block;
      }

      .obtain_evidence_item_close{
          display: block;
          width: 18px;
          height: 18px;
          cursor: pointer;
      }
  }
}
.submit-button {
    width: 230px;
    height: 42px;
    background: rgba(255, 216, 0, 1);
    border-radius: 4px;
    line-height: 42px;
    font-size: 14px;
    font-weight: 600;
    color: rgba(78, 78, 78, 1);
    cursor: pointer;
    border: none;
    outline: none;
}
</style>
